import {
  Box,
  Center,
  Flex,
  Image,
  Stack,
  useBreakpointValue,
  useColorModeValue,
} from '@chakra-ui/react';
import { Button, FormError, LoadingState } from '@main/complykit';
import { useEffect } from 'react';

import { useBackofficeDispatch, useBackofficeSelector } from '../../hooks/redux-toolkit-hooks';
import { getUserSSOState, samlSSOInitiated, signInPageLoaded } from './slice';

export const SignIn = () => {
  const dispatch = useBackofficeDispatch();
  const { authStatus, error } = useBackofficeSelector(getUserSSOState);

  const bg = useBreakpointValue({ base: 'transparent', md: 'bg-surface' });
  const shadow = { base: 'none', md: useColorModeValue('md', 'dark-lg') };
  const logo = useColorModeValue('/logo.svg', '/logo_dark.svg');

  useEffect(() => {
    dispatch(signInPageLoaded());
  }, [dispatch]);

  const renderError = () => {
    if (!error) {
      return null;
    }

    switch (error) {
      default:
        return (
          <Box mt={4}>
            <FormError>{error}</FormError>
          </Box>
        );
    }
  };

  if (authStatus === 'VERIFYING') {
    return (
      <Center h="100vh">
        <LoadingState />
      </Center>
    );
  }

  return (
    <Flex py="12" minH="100vh" alignItems="center" justifyContent="center">
      <Stack spacing={8} mx="auto" maxW="lg" w="lg">
        <Box
          py={{ base: '0', md: '12' }}
          px={{ base: '4', md: '10' }}
          bg={bg}
          boxShadow={shadow}
          borderRadius={{ base: 'none', md: 'xl' }}
        >
          <Image
            alt="logo"
            objectFit="contain"
            sizes="100vw"
            src={logo}
            decoding="async"
            width="100%"
            height="14"
            p={3}
          />
          <Flex direction="column" mt={6}>
            <Button
              size="lg"
              onPress={() => {
                dispatch(samlSSOInitiated());
              }}
            >
              Sign in with SSO
            </Button>
          </Flex>
          {renderError()}
        </Box>
      </Stack>
    </Flex>
  );
};
